import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/fin-mon';
import widgetsHelper from 'utils/getWidget.helper';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: tpl,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            faqTab: false
        };

        this.widgetsHelper = widgetsHelper;
    }

    componentWillReady() {
        this.widgetsHelper.getWidgets.call(this);
    }

    toggleFaqTab = () => {
        this.setState({faqTab: !this.state.faqTab}, () => {
            const faqElement = document.querySelector('.content');
            if (faqElement) {
                faqElement.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
            }
        });
    };
}
